@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.ridepayment

import com.narbase.letsgo.web.dto.currency.CurrencyDto
import com.narbase.letsgo.web.dto.rides.RideDto

data class ExtendedRidePaymentDto(
    val ride: RideDto,
    val ridePayment: RidePaymentDto,
    val currency: CurrencyDto,
)
